<script setup lang="ts">
import { computed } from 'vue';
import { useCurrentUserComposable } from '@src/user/composable/current-user-composable.ts';

const props = defineProps<{
    allowedRoles: Array<string>
}>();
const { currentUser } = useCurrentUserComposable();

const show = computed(() => {
    if (currentUser.value === null) {
        return false;
    }
    for (let count = 0; count < props.allowedRoles.length; count++) {
        const allowedRole = props.allowedRoles[count];
        if (currentUser.value.roles.includes(allowedRole)) {
            return true;
        }
    }
    return false;
});
</script>

<template>
    <!-- eslint-disable-next-line vue/no-multiple-template-root -->
    <slot v-if="show"/>
</template>
